const $$splitComponentImporter = () => import('/home/runner/work/touring-host-app/touring-host-app/src/routes/_rootLayout/dashboard.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { t } from 'i18next';
export const Route = createFileRoute('/_rootLayout/dashboard')({
  loader: async () => ({
    crumb: t('NAVIGATION.DASHBOARD'),
    to: '/dashboard'
  }),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});